// Imports
import planMapping from './plan-mapping';
import currency from 'currency.js';

/* Define extended pricing range details */
const extendedPricingDetails: Record<
	number,
	{ start: number; end: number; step: number; tiers: Record<number | 'default', InstanceType<typeof currency>> }
> = {
	[planMapping.engage]: {
		start: 1000,
		end: 10000,
		step: 100,
		tiers: {
			1000: currency(9, { fromCents: true }),
			2000: currency(7, { fromCents: true }),
			3000: currency(5, { fromCents: true }),
			4000: currency(3, { fromCents: true }),
			5000: currency(2, { fromCents: true }),
			default: currency(5, { fromCents: true }),
		},
	},
};

export default extendedPricingDetails;
